import React, { FunctionComponent, useState } from 'react';
import SectionStatesWrapper, {
  ISectionStatesProps,
} from '../../../../../../common/components/configuratorStates/SectionStatesWrapper';
import CustomiseColorOptionsList from '../customiseOptions/colorOption/CustomiseColorOptionsList';
import CustomiseCategories from '../customiseCategory/CustomiseCategories';
import ISection from '../../../../../model/ISection';
import CustomiseCheckboxPacksList from '../customiseOptions/checkboxOptionPack/CustomiseCheckboxPacksList';
import IFeatureSections from '../../../../../model/IFeatureSections';
import AccessoryPackModal from '../accessoryPacks/accessoryPackModal/AccessoryPackModal';
import { useCheckSelectedFeatures } from '../../../../../hooks/features/useCheckSelectedFeatures';
import IFeature from '../../../../../model/IFeature';
import FeatureServicePlanItemList from '../../features/featureServicePlan/featureServicePlanList/FeatureServicePlanItemList';
import useCustomizeCarContext from '../../../../../hooks/useCustomizeCarContext';

export interface ICustomiseSectionDetailsProps extends ISectionStatesProps {
  section: ISection;
  loading: boolean;
}

const CustomiseSectionDetails: FunctionComponent<ICustomiseSectionDetailsProps> = ({ loading, error, section }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const { handleCheckboxChange } = useCheckSelectedFeatures();
  const { optimisticSelectedFeatures } = useCustomizeCarContext();
  const [selectedOption, setSelectedOption] = useState<IFeature>(null);

  const openAccessoryPackModal = (value: boolean, optionCode: string) => {
    const selectedOption = section?.featuresList?.features.find(feature => feature.code === optionCode);
    setModalOpen(value);
    setSelectedOption(selectedOption);
  };

  const mapSections = [
    {
      sectionNames: [IFeatureSections.EXTERIOR, IFeatureSections.INTERIOR],
      component: (
        <CustomiseColorOptionsList
          key={section.code}
          featuresList={section.featuresList}
          data-test={`options:category:${section.code}`}
        />
      ),
    },
    {
      sectionNames: [IFeatureSections.ACCESSORY_PACK],
      component: (
        <CustomiseCheckboxPacksList
          key={section.code}
          features={section.featuresList.features}
          openAccessoryPackModal={openAccessoryPackModal}
          handleCheckboxChange={handleCheckboxChange}
        />
      ),
    },
    {
      sectionNames: [IFeatureSections.ACCESSORY],
      component: <CustomiseCategories key={section.code} categories={section.categories} />,
    },
    {
      sectionNames: [IFeatureSections.SERVICE_PLAN],
      component: (
        <FeatureServicePlanItemList
          key={section.code}
          features={section.featuresList.features}
          onClick={handleCheckboxChange}
        />
      ),
    },
  ];

  return (
    <>
      <SectionStatesWrapper error={error} loading={loading || !section}>
        {mapSections.map(
          ({ sectionNames, component }) => sectionNames.includes(section.code as IFeatureSections) && component,
        )}
      </SectionStatesWrapper>
      <AccessoryPackModal
        onToggle={handleCheckboxChange}
        featureCode={selectedOption?.code}
        name={selectedOption?.name}
        prices={selectedOption?.prices}
        isSelected={optimisticSelectedFeatures?.includes(selectedOption?.code)}
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default CustomiseSectionDetails;
